"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CapabilityStatement_Messaging = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CapabilityStatement_Endpoint_1 = require("./RTTI_CapabilityStatement_Endpoint");
var RTTI_unsignedInt_1 = require("../Scalar/RTTI_unsignedInt");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_CapabilityStatement_SupportedMessage_1 = require("./RTTI_CapabilityStatement_SupportedMessage");
exports.RTTI_CapabilityStatement_Messaging = t.recursion('ICapabilityStatement_Messaging', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        endpoint: t.array(RTTI_CapabilityStatement_Endpoint_1.RTTI_CapabilityStatement_Endpoint),
        reliableCache: RTTI_unsignedInt_1.RTTI_unsignedInt,
        _reliableCache: RTTI_Element_1.RTTI_Element,
        documentation: RTTI_markdown_1.RTTI_markdown,
        _documentation: RTTI_Element_1.RTTI_Element,
        supportedMessage: t.array(RTTI_CapabilityStatement_SupportedMessage_1.RTTI_CapabilityStatement_SupportedMessage)
    });
});
//# sourceMappingURL=RTTI_CapabilityStatement_Messaging.js.map